// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__10dAW","right":"Footer_right__2jjhf","buttons":"Footer_buttons__42_E8"};